import React, { createContext, useContext, useState } from "react";

export enum FilterSortType {
  ASCENDING = "ASCENDING",
  DESCENDING = "DESCENDING",
  UNSET = "UNSET",
}

export interface filterStateI {
  orderBy: string;
  isFreeCancelable: boolean | FilterSortType;
  priceRange?: Array<number>;
  amenitiesIds: string[];
  hotelTypeIds: string[];
}

const FilterContext = createContext<{}>({});

const FilterContextProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [filterState, setFilterState] = useState();
  return <FilterContext.Provider value={{}}>{children}</FilterContext.Provider>;
};

export default FilterContextProvider;

export const useFilterContext = () => useContext(FilterContext);
